var _rect, _path, _rect2, _rect3, _path2, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBagpack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.73962,
    y: 3.10791,
    width: 6.26728,
    height: 3.5023,
    rx: 1.75115,
    stroke: "#FFB800",
    strokeWidth: 1.47465
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8364 22.1863V22.6471H17.2972H19.5092C19.827 22.6471 20.1317 22.5209 20.3564 22.2962C20.5811 22.0715 20.7074 21.7667 20.7074 21.449V10.3891C20.7074 9.09352 20.1927 7.85106 19.2767 6.93498C18.3606 6.0189 17.1181 5.50426 15.8226 5.50426H9.92396C8.62844 5.50426 7.38597 6.0189 6.46989 6.93498C5.55382 7.85106 5.03917 9.09352 5.03917 10.3891V21.449C5.03917 21.7667 5.1654 22.0715 5.3901 22.2962L5.71596 21.9703L5.3901 22.2962C5.6148 22.5209 5.91956 22.6471 6.23733 22.6471H8.44931H8.91014V22.1863V15.5503C8.91014 15.2815 9.01695 15.0236 9.20708 14.8335C9.39721 14.6433 9.65508 14.5365 9.92396 14.5365H15.8226C16.0915 14.5365 16.3493 14.6433 16.5395 14.8335C16.7296 15.0236 16.8364 15.2815 16.8364 15.5503V22.1863Z",
    fill: "#FFDC3F",
    stroke: "#FFDC3F",
    strokeWidth: 0.921659
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35712,
    y: 17.2092,
    width: 9.03226,
    height: 5.89862,
    fill: "#FFFCE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0069,
    y: 16.4719,
    width: 2.39631,
    height: 1.29032,
    rx: 0.645161,
    transform: "rotate(90 16.0069 16.4719)",
    fill: "#83794B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35712 15.6424C8.35712 14.7262 9.09987 13.9834 10.0161 13.9834H15.7304C16.6466 13.9834 17.3894 14.7262 17.3894 15.6424V17.2092H8.35712V15.6424Z",
    fill: "#FFB800"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1083,
    y: 8.63794,
    width: 5.52995,
    height: 1.65899,
    rx: 0.829493,
    fill: "#83794B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagpack);
export default __webpack_public_path__ + "static/media/Bagpack.905734d0e47bca98c11d6f937547da83.svg";
export { ForwardRef as ReactComponent };